module.exports = __webpack_public_path__ + "img/pp4.f8e407da.png";